<nav
  class="relative z-30 w-full bg-[#FCFCFD] dark:bg-[#0C0C1A] font-canvi pt-5 sm:pt-6"
>
  <div
    class="flex flex-wrap justify-between items-center min-h-20 px-4 gap-2 sm:gap-4"
  >
    <!-- Área do título e controle -->
    <div class="flex items-center gap-4">
      <!-- Título -->
      <h1
        class="mt-3 max-w-[80vw] break-words font-canvi font-normal text-[24px] leading-[1.2] text-center sm:text-left"
      >
        @if (tituloAtual.includes("/")) {
          <!-- Primeira parte do título -->
          <span class="text-gray-400 text-base sm:text-lg md:text-xl">
            {{ tituloAtual.split("/")[0] }}
          </span>

          <!-- Segunda parte com destaque -->
          <span
            class="ml-4 titulo-navbar font-canvi font-normal text-[24px] md:text-[24px] sm:text-[20px]"
          >
            / {{ tituloAtual.split("/")[1] }}
          </span>
        } @else {
          <span
            class="titulo-navbar font-canvi font-semibold text-[24px] leading-[1.2]"
            [ngClass]="{ 'titulo-menu-rapido': tituloAtual === 'Menu rápido' }"
          >
            {{ tituloAtual }}
          </span>
        }
      </h1>
    </div>

    <!-- Área da pesquisa + usuário -->
    <div
      class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 ml-auto mr-4 sm:mr-8 w-full sm:w-auto"
    >
      @if (pesquisaNavbarVisivel) {
        <div
          class="relative order-2 sm:order-1 w-full sm:w-[260px] mt-4 sm:mt-0"
        >
          <input
            type="text"
            class="campo-input h-11 sm:h-12 pr-12 text-sm placeholder-[#a0aec0] dark:placeholder-[#9ca3af] focus:ring-0 focus:border-transparent focus-within:ring-1 focus-within:ring-[#323396]/40"
            [placeholder]="placeholderPesquisaNavbar"
            [(ngModel)]="valorPesquisaNavbar"
            (ngModelChange)="onNavbarSearchChange($event)"
            autocomplete="off"
          />

          <div class="absolute inset-y-0 right-2 flex items-center gap-1">
            <button
              type="button"
              class="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-black/5 dark:hover:bg-white/10 transition"
              aria-label="Pesquisar"
              title="Pesquisar"
              (click)="onNavbarSearchChange(valorPesquisaNavbar)"
            >
              <img
                src="/icons/icons-datatable/iconPesquisar.png"
                alt=""
                class="w-5 h-5 opacity-80 dark:opacity-90 dark:invert"
              />
            </button>

            @if (valorPesquisaNavbar) {
              <button
                type="button"
                class="w-9 h-9 flex items-center justify-center rounded-lg hover:bg-black/5 dark:hover:bg-white/10 transition"
                aria-label="Limpar pesquisa"
                title="Limpar pesquisa"
                (click)="limparBuscaNavbar()"
              >
                <img
                  src="/icons/icons-navbar-submenu/iconX.svg"
                  alt="Limpar"
                  class="w-4 h-4 opacity-70 dark:opacity-100 dark:invert"
                />
              </button>
            }
          </div>
        </div>
      }

      <div
        class="flex items-center gap-4 order-1 sm:order-2 justify-end relative z-[100]"
      >
        <div class="flex items-center gap-0 cursor-pointer relative">
          <!-- Foto -->
          <div
            class="w-[50px] h-[50px] flex-shrink-0 bg-gradient-to-r from-pink-500 to-purple-500 rounded-full p-[2px] hidden sm:block"
          >
            <div class="w-full h-full bg-white rounded-full overflow-hidden">
              <img
                class="w-full h-full object-cover object-center"
                src="icons/icons-navbar-submenu/iconPessoa.png"
                alt="Foto do usuário"
              />
            </div>
          </div>

          <!-- Bloco da saudação + seta com BG e clique -->
          <div
            #areaUsuario
            class="inline-flex items-center gap-2 px-3 py-1.5 rounded-xl transition-colors hover:bg-[#F4F7FB] dark:hover:bg-[#303049]"
            [ngClass]="dropdownAberto ? 'bg-[#F4F7FB] dark:bg-[#303049]' : ''"
            (click)="alternarDropdown()"
          >
            <!-- Saudação -->
            <span
              class="mt-2 self-stretch font-canvi font-normal text-sm leading-[1.2] tracking-normal text-[#0c0c1a] dark:text-[#f4f7fb]"
            >
              Olá, {{ usuario?.nome }}
            </span>

            <!-- Ícone seta alinhado -->
            <img
              [src]="
                isDarkMode
                  ? '/icons/icons-navbar-submenu/setaDark.svg'
                  : '/icons/icons-navbar-submenu/seta.svg'
              "
              class="w-5 h-5 mt-[8px] transition-transform duration-200"
              [ngClass]="{ 'rotate-90': dropdownAberto }"
              alt="Seta"
            />
          </div>

          <!-- Botão de alternância de tema -->
          <button
            (click)="onToggleDarkMode(); $event.stopPropagation()"
            class="flex items-center justify-center w-7 h-7 cursor-pointer sm:w-10 sm:h-10 mt-2"
            title="Alternar tema"
          >
            <img
              [src]="
                isDarkMode
                  ? 'icons/icons-navbar-submenu/iconDarkMode.svg'
                  : 'icons/icons-navbar-submenu/iconLightMode.svg'
              "
              alt="Modo"
              class="w-5 h-5"
            />
          </button>

          <!-- Menu Usuário -->
          <div
            #dropdownUsuario
            [class.hidden]="!dropdownAberto"
            class="user-menu font-canvi absolute right-0 top-full mt-2 w-[min(92vw,340px)] h-auto max-h-[380px] overflow-hidden py-3 px-3 rounded-2xl shadow-xl z-[9999] text-sm"
          >
            <div class="user-menu__scroll overflow-y-auto max-h-[340px]">
              <!-- Informações do usuário -->
              <div class="user-menu__header">
                <span class="user-menu__name">{{ usuario?.nome }}</span>
                <span class="user-menu__email">{{ usuario?.email }}</span>
              </div>

              <!-- Opções -->
              <ul class="user-menu__list">
                <li class="user-menu__group">
                  <button
                    type="button"
                    class="user-menu__item user-menu__item--parent"
                    (click)="toggleSubMenu('config')"
                  >
                    <span class="user-menu__icon" aria-hidden="true">
                      <lucide-icon
                        name="wrench"
                        [size]="18"
                        [strokeWidth]="1.6"
                      ></lucide-icon>
                    </span>
                    <span class="user-menu__label">Configurações</span>
                    <img
                      [src]="
                        isDarkMode
                          ? '/icons/icons-navbar-submenu/setaDark.svg'
                          : '/icons/icons-navbar-submenu/seta.svg'
                      "
                      class="user-menu__caret"
                      [ngClass]="{
                        'user-menu__caret--open': subMenuOpen['config'],
                      }"
                      alt="Abrir Configurações"
                    />
                  </button>

                  @if (subMenuOpen["config"]) {
                    <ul class="user-menu__submenu">
                      <li>
                        <button
                          type="button"
                          class="user-menu__submenu-item"
                          (click)="selecionarOpcao('SubConfig1')"
                        >
                          teste
                        </button>
                      </li>
                      <li>
                        <button
                          type="button"
                          class="user-menu__submenu-item"
                          (click)="selecionarOpcao('SubConfig2')"
                        >
                          teste
                        </button>
                      </li>
                    </ul>
                  }
                </li>

                <li class="user-menu__group">
                  <button
                    type="button"
                    class="user-menu__item user-menu__item--parent"
                    (click)="toggleSubMenu('seguranca')"
                  >
                    <span class="user-menu__icon" aria-hidden="true">
                      <lucide-icon
                        name="shield"
                        [size]="18"
                        [strokeWidth]="1.6"
                      ></lucide-icon>
                    </span>
                    <span class="user-menu__label">Segurança</span>
                    <img
                      [src]="
                        isDarkMode
                          ? '/icons/icons-navbar-submenu/setaDark.svg'
                          : '/icons/icons-navbar-submenu/seta.svg'
                      "
                      class="user-menu__caret"
                      [ngClass]="{
                        'user-menu__caret--open': subMenuOpen['seguranca'],
                      }"
                      alt="Abrir Segurança"
                    />
                  </button>

                  @if (subMenuOpen["seguranca"]) {
                    <ul class="user-menu__submenu">
                      <li>
                        <button
                          type="button"
                          class="user-menu__submenu-item"
                          (click)="selecionarOpcao('SubSeguranca1')"
                        >
                          teste
                        </button>
                      </li>
                    </ul>
                  }
                </li>

                <li class="user-menu__group">
                  <button
                    type="button"
                    class="user-menu__item user-menu__item--parent"
                    (click)="toggleSubMenu('perfil')"
                  >
                    <span class="user-menu__icon" aria-hidden="true">
                      <lucide-icon
                        name="user"
                        [size]="18"
                        [strokeWidth]="1.6"
                      ></lucide-icon>
                    </span>
                    <span class="user-menu__label">Perfil</span>
                    <img
                      [src]="
                        isDarkMode
                          ? '/icons/icons-navbar-submenu/setaDark.svg'
                          : '/icons/icons-navbar-submenu/seta.svg'
                      "
                      class="user-menu__caret"
                      [ngClass]="{
                        'user-menu__caret--open': subMenuOpen['perfil'],
                      }"
                      alt="Abrir Perfil"
                    />
                  </button>

                  @if (subMenuOpen["perfil"]) {
                    <ul class="user-menu__submenu">
                      <li>
                        <button
                          type="button"
                          class="user-menu__submenu-item"
                          (click)="selecionarOpcao('SubPerfil1')"
                        >
                          teste
                        </button>
                      </li>
                    </ul>
                  }
                </li>

                <li class="user-menu__group">
                  <button
                    type="button"
                    class="user-menu__item user-menu__item--parent"
                    (click)="toggleSubMenu('notificacoes')"
                  >
                    <span class="user-menu__icon" aria-hidden="true">
                      <lucide-icon
                        name="bell"
                        [size]="18"
                        [strokeWidth]="1.6"
                      ></lucide-icon>
                    </span>
                    <span class="user-menu__label">Notificações</span>
                    <img
                      [src]="
                        isDarkMode
                          ? '/icons/icons-navbar-submenu/setaDark.svg'
                          : '/icons/icons-navbar-submenu/seta.svg'
                      "
                      class="user-menu__caret"
                      [ngClass]="{
                        'user-menu__caret--open': subMenuOpen['notificacoes'],
                      }"
                      alt="Abrir Notificações"
                    />
                  </button>

                  @if (subMenuOpen["notificacoes"]) {
                    <ul class="user-menu__submenu">
                      <li>
                        <button
                          type="button"
                          class="user-menu__submenu-item"
                          (click)="selecionarOpcao('SubNotificacoes1')"
                        >
                          teste
                        </button>
                      </li>
                      <li>
                        <button
                          type="button"
                          class="user-menu__submenu-item"
                          (click)="selecionarOpcao('SubNotificacoes2')"
                        >
                          teste
                        </button>
                      </li>
                    </ul>
                  }
                </li>
              </ul>

              <div class="user-menu__divider" aria-hidden="true"></div>

              <!-- Sair -->
              <button
                type="button"
                class="user-menu__logout"
                (click)="logout()"
              >
                <span class="user-menu__logout-label">
                  <img
                    src="/icons/icons-sidebar/iconSair.svg"
                    class="user-menu__logout-icon"
                    alt="Sair"
                  />
                  Sair
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w-full h-[1px] bg-[#EDEAF0] dark:bg-[#303049]"></div>
  </div>
</nav>
